import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-product-banner',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './product-banner.component.html',
    styleUrl: './product-banner.component.scss',
})
export class ProductBannerComponent {
    @Input() selectedLanguage: string;
    @Input() showBanks: boolean = false;
    @Input() showAlternateFinancing: boolean = false;
    @Input() isDGP: boolean = false;

    banner: any;

    constructor() {}

    ngOnChanges() {
        if (this.showBanks) {
            this.banner =
                this.selectedLanguage == 'bm'
                    ? '/assets/images/products/product_list_banner_BM.webp'
                    : '/assets/images/products/product-banner-01.png';
        } else if (this.showAlternateFinancing) {
            this.banner = '/assets/images/products/dgp-mbl.webp';
        }
    }
}
